import React from 'react';
import { Route, IndexRoute } from 'react-router';

import CoreLayout from 'catalog/layouts/CoreLayout';
import NodeLayout from 'catalog/layouts/NodeLayout';

import NodeChildrenPage from 'catalog/pages/NodeChildrenPage';
import NodeEditionPage from 'catalog/pages/NodeEditionPage';
import NodeProductsPage from 'catalog/pages/NodeProductsPage';
import NodePestsPage from 'catalog/pages/NodePestsPage';
import NodeTipsPage from 'catalog/pages/NodeTipsPage';
import NodeMemosPage from 'catalog/pages/NodeMemosPage';

export default (store, catalog) => (
  <Route path="/" component={CoreLayout} catalog={catalog}>
    <Route component={NodeLayout}>
      <IndexRoute component={NodeChildrenPage} />
      <Route path="nodes/:id" component={NodeChildrenPage} />
      <Route path="nodes/:parent/new" component={NodeEditionPage} />
      <Route path="nodes/:id/edit" component={NodeEditionPage} />
      <Route path="nodes/:id/products" component={NodeProductsPage} />
      <Route path="nodes/:id/pests" component={NodePestsPage} />
      <Route path="nodes/:id/tips" component={NodeTipsPage} />
      <Route path="nodes/:id/memos" component={NodeMemosPage} />
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./src/modules/catalog/routes/index.js